import React from 'react';
import OcLogoRow from './OcLogoRow';
import './OcRequestStyle.css';

/**
 * Lab / public OC workspace chrome.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {boolean} [props.showLogos] - partner logo strip (default true)
 * @param {boolean} [props.wide] - wider max width for inbox/tables
 * @param {React.ReactNode} [props.banner] - optional banner above content
 * @param {'mint'|'yellow'} [props.theme='mint'] - mint = public branding; yellow = Procure lab
 */
const OcWorkspaceShell = ({
  children,
  showLogos = true,
  wide = false,
  banner = null,
  theme = 'mint',
}) => (
  <div
    className={`oc-page${theme === 'yellow' ? ' oc-page--yellow' : ''}`}
  >
    <div className={`oc-page__inner${wide ? ' oc-page__inner--wide' : ''}`}>
      {showLogos ? <OcLogoRow compact /> : null}
      {banner}
      {children}
    </div>
  </div>
);

export default OcWorkspaceShell;
